import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { emitEvent } from 'lib/eventManager';

import TOAST from '../constants/toast';

const useToast = () => {
  const router = useRouter();

  const showToast = (props = {}) => emitEvent(TOAST.EVENTS.SHOW_TOAST, props);

  const hideToasts = () => emitEvent(TOAST.EVENTS.HIDE_ALL_TOASTS);

  useEffect(() => {
    router.events.on('routeChangeStart', hideToasts);

    return () => {
      router.events.off('routeChangeStart', hideToasts);
    };
  }, []);

  return { showToast, hideToasts };
};

export default useToast;
